import { FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { ApplicationService } from '../../services/application/application.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { PhonePipe } from '../../pipes/phone.pipe';
import { phoneNumberValidator } from '../../validators/phonenumber.validator';
var StudentContactComponent = /** @class */ (function () {
    function StudentContactComponent(appService, errorService, fb, phonePipe, splashService, userService) {
        this.appService = appService;
        this.errorService = errorService;
        this.fb = fb;
        this.phonePipe = phonePipe;
        this.splashService = splashService;
        this.userService = userService;
        this._subRelease = new Subject();
    }
    Object.defineProperty(StudentContactComponent.prototype, "phone", {
        get: function () {
            return this.contactForm.get('ContactPhone');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StudentContactComponent.prototype, "email", {
        get: function () {
            return this.contactForm.get('ContactEmail');
        },
        enumerable: true,
        configurable: true
    });
    StudentContactComponent.prototype.ngOnInit = function () {
        var self = this;
        self.LoadedEmail = null;
        self.LoadedPhone = null;
        self.PartialViewReady = false;
        self.StudentInfo = null;
        self.User = null;
        self.userService.UserSubject.pipe(takeUntil(self._subRelease), first(function (user) { return user != null && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subRelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load student info so we can get access to the student ID and the current contact info
            combineLatest(self.appService.GetStudentSchoolInformation(self.User.AuthToken), function (student) {
                return {
                    Student: student,
                };
            })
                .pipe(takeUntil(self._subRelease))
                .subscribe(function (packet) {
                self.StudentInfo = packet.Student;
                self.LoadedEmail = self.StudentInfo.StudentEmail;
                var formattedPhone = self.phonePipe.transform(self.StudentInfo.StudentPhone, 'parensdash');
                self.LoadedPhone = formattedPhone;
                if (!self.contactForm) {
                    self.contactForm = self.fb.group({
                        ContactPhone: [formattedPhone, phoneNumberValidator()],
                        ContactEmail: [
                            self.StudentInfo.StudentEmail,
                            Validators.pattern(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i),
                        ],
                    });
                }
                else {
                    self.contactForm.setValue({
                        ContactPhone: formattedPhone,
                        ContactEmail: self.StudentInfo.StudentEmail,
                    });
                }
                self.PartialViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    StudentContactComponent.prototype.ngOnDestroy = function () {
        this._subRelease.next();
        this._subRelease.complete();
    };
    // #region Update Student Contact Info Method
    StudentContactComponent.prototype.UpdateStudentContactInfo = function () {
        var self = this;
        var form = self.contactForm.value;
        if (!self.contactForm.valid) {
            return;
        }
        var cleanPhone = form.ContactPhone.replace(/[\(\)\-\s]/g, '');
        this.appService
            .UpdateStudentContactInfo(self.User.AuthToken, self.StudentInfo.StudentID, cleanPhone, form.ContactEmail)
            .subscribe(function (info) {
            var formattedPhone = self.phonePipe.transform(info.Phone, 'parensdash');
            self.contactForm.setValue({
                ContactPhone: formattedPhone,
                ContactEmail: info.EmailAddress,
            });
            self.LoadedEmail = info.EmailAddress;
            self.LoadedPhone = formattedPhone;
            self.splashService.SnackbarSuccess('Contact information updated successfully.');
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    return StudentContactComponent;
}());
export { StudentContactComponent };



// WEBPACK FOOTER //
// ./src/app/studentcontact/studentcontact.component.ts.pre-build-optimizer.js